export { filterHistoryItemsByCalendar } from "./historyUtils";

export function deriveChatTitle(item: { input?: string }): string {
  if (!item.input) return "Untitled chat";
  if (!item.input.startsWith("[Context]\n")) {
    return item.input.trim() || "Untitled chat";
  }
  const end = item.input.indexOf("\n[/Context]\n");
  if (end === -1) {
    return item.input.trim() || "Untitled chat";
  }
  return (
    item.input.slice(end + "\n[/Context]\n".length).trim() || "Untitled chat"
  );
}

export function stripContextPrefix(input: string): string {
  if (input.startsWith("[Context]\n")) {
    const end = input.indexOf("\n[/Context]\n");
    if (end !== -1) {
      return input.slice(end + "\n[/Context]\n".length);
    }
  }
  return input;
}
